import { render, staticRenderFns } from "./IndicatorsSection.vue?vue&type=template&id=640e273f"
import script from "./IndicatorsSection.vue?vue&type=script&lang=js"
export * from "./IndicatorsSection.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsSection.vue?vue&type=style&index=0&id=640e273f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports